module.exports = __webpack_public_path__ + "static/media/instagram-bk.48569d46.png";